import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';


export const autocompleteStyles = makeStyles((theme) => ({
    autocompleteWrapper: {
        position: 'relative',

        '& .autocomplete': {
            '&-container': {
                background: tcsmColors.white,
                border: `1px solid ${tcsmColors.greyFive}`,
                position: 'absolute',
                zIndex: '1',
                left: '0',
                width:'100%',
            },
            '&-list': {
                '&-item': {
                    '&-button': {
                        display: 'block',
                        width: '100%',
                        padding: theme.spacing(.25),
                        color: tcsmColors.blue,
                        textDecoration: 'underline',
                        '&:hover': {
                            background: tcsmColors.greyFive,
                            textDecoration: 'none',
                        },
                    },
                },
            },
            marginLeft: theme.spacing(.5),
            '& > div': {
                top: '2px', //This is a override of the component positioning
            },
        },
    },

}));



